import { render } from "./CtaIot.vue?vue&type=template&id=105aa2c4"
import script from "./CtaIot.vue?vue&type=script&lang=js"
export * from "./CtaIot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__